import * as React from 'react';
import { LoadingIcon, forwardInnerRef } from 'localmed-core';

import Button, { IButtonProps } from './DiButton';

export type Props = IButtonProps & {
  /** Default button text. */
  defaultText?: string;
  /** Button text during submission. */
  submittingText?: string;
  /** Set button to the submitting state. */
  submitting?: boolean;
};

function SubmitButton({
  defaultText = 'Submit',
  submittingText = 'Submitting',
  submitting = false,
  icon,
  ...props
}: Props) {
  return (
    <Button
      {...props}
      loading={submitting}
      type="submit"
      icon={submitting ? <LoadingIcon /> : icon}
    >
      {submitting ? `${submittingText}…` : defaultText}
    </Button>
  );
}

export default forwardInnerRef<Props, void>(SubmitButton);
